import React from "react";
import Editor from "../../components/Editor";
import { FormGroup, Label, FormFeedback } from "reactstrap";

export default props => {
  const { input, label, id, placeholder, meta = {} } = props;
  return (
    <FormGroup>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Editor
        id={id}
        onBlur={html => input.onChange(html)}
        content={input.value}
        placeholder={placeholder}
      />
      {meta.error && meta.touched && <FormFeedback>{meta.error}</FormFeedback>}
    </FormGroup>
  );
};
